var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 91,
    viewBox: "0 0 90 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "play",
    clipPath: "url(#clip0_5058_4718)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 11",
    cx: 45,
    cy: 45.5,
    r: 45,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "play-icon",
    d: "M63.1956 45.5851C63.1097 45.1371 62.9094 44.7071 62.6232 44.3397C60.7917 41.9744 57.1288 40.4064 54.6391 38.7937C53.027 37.7544 51.3863 36.7509 49.7838 35.7026C48.9348 35.1292 48.0954 34.5378 47.2941 33.9196C46.3116 33.1581 45.3673 32.3696 44.4038 31.5991C41.8092 29.5294 37.9269 25.5065 34.3116 27.388C33.0525 28.1406 32.2798 29.4487 32.2703 30.8554C32.213 32.9341 32.1558 35.0037 32.0318 37.0824C31.9078 39.0356 31.7456 40.9888 31.6121 42.942C31.4785 44.8773 31.3355 46.8126 31.2496 48.7569C31.2019 49.7603 31.1733 50.7549 31.1542 51.7584C31.1161 53.6668 30.973 56.4532 31.6693 58.2452C32.69 60.8614 34.8553 60.055 36.8585 59.1949C39.0715 58.2541 41.2941 57.3313 43.5072 56.3905C45.8347 55.396 48.1717 54.4552 50.566 53.613C53.1892 52.6902 55.7075 51.5523 58.3307 50.6474C58.8935 50.4592 59.4658 50.289 60.0191 50.0918C61.946 49.3751 63.5485 47.4308 63.2051 45.5851M55.6502 46.1765C54.5342 46.5797 53.4467 47.0366 52.3593 47.4846C50.0127 48.4343 47.5994 49.2048 45.2528 50.1456C43.1638 50.9789 41.1129 51.8838 39.0429 52.7708C38.2321 53.1202 37.4022 53.4517 36.5819 53.7922C36.5342 53.0575 36.5437 52.3228 36.5533 51.5881C36.5628 50.6205 36.601 49.6528 36.6391 48.6941C36.725 46.7588 36.8681 44.8325 37.0016 42.9062C37.1351 40.8992 37.2878 38.8922 37.4309 36.8853C37.5262 35.604 37.5739 34.3228 37.6121 33.0416C38.8331 33.8838 40.0254 34.7618 41.1892 35.6847C42.6296 36.8315 44.0318 37.9873 45.5485 39.0446C47.132 40.1376 48.7631 41.1501 50.3943 42.1805C51.9396 43.1481 53.4658 44.1337 54.9921 45.1282C55.4213 45.4059 55.8506 45.6837 56.2703 45.9883C56.0604 46.051 55.8601 46.1227 55.6598 46.1944L55.6502 46.1765Z",
    fill: "#14294E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5058_4718",
    x1: 0.00000134054,
    y1: 77.7018,
    x2: 90,
    y2: 17.8395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#40B449"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4D82E"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5058_4718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
export default SvgPlay;